import React from 'react';
import PropTypes from 'prop-types';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import css from './ConnectionsListPlaceholder.scss';
import { range } from 'lodash';
import ConnectionItemPlaceholder from './ConnectionItemPlaceholder';

export default class ConnectionsListPlaceholder extends React.Component {

	get lines() {
		return range(this.props.numberOfItems)
      .map(index => <ConnectionItemPlaceholder numberOfLines={this.props.numberOfLines} key={index} />);
	}

	render() {
		return (
			<Dimmer.Dimmable as={Segment} blurring dimmed>
				<Dimmer active inverted><Loader>{this.props.loadingText}</Loader></Dimmer>
				<div className={css['placeholder']}>{this.lines}</div>
			</Dimmer.Dimmable>
		);
	}
}

ConnectionsListPlaceholder.defaultProps = {
	numberOfItems: 2,
  numberOfLines: 2,
	loadingText: "Loading"
};

ConnectionsListPlaceholder.propTypes = {
	numberOfItems: PropTypes.number.isRequired,
  numberOfLines: PropTypes.number.isRequired,
	loadingText: PropTypes.string.isRequired
};
